<template>

    <div class="ma-5">
        <v-row>
            <v-col cols="12" class="ma-0 pa-0">
                <v-carousel
                        hide-delimiter-background
                        hide-delimiters
                        :show-arrows="this.product.retro !== ''"
                        :show-arrows-on-hover="!isMobile() && this.product.retro !== ''"
                        height="100%"
                >
                    <v-carousel-item :key="'slide1' + product.photo" >
                        <v-img
                                :src="require('../assets/' + product.photo)"
                                :lazy-src="require('../assets/' + product.photomin)"
                                contain
                                height="500px"
                                width="100%"
                                @click="dialog = true"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                >
                                    <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                    ></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </v-carousel-item>
                    <v-carousel-item v-if="product.retro !== ''" :key="'slide2' + product.photo" >
                        <v-img
                                :src="require('../assets/' + product.retro)"
                                :lazy-src="require('../assets/' + product.retromin)"
                                contain
                                height="500px"
                                width="100%"
                                @click="dialog = true"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                >
                                    <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                    ></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </v-carousel-item>
                </v-carousel>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="auto">
                <p class="mb-0"><b>{{product.prod1}}</b> <span style="font-size: 13px">{{product.stile1}} {{product.taglia1}}</span></p>
                <p class="mb-0"><b>{{product.prod2}}</b> <span style="font-size: 13px">{{product.stile2}} {{product.taglia2}}</span></p>
                <p class="mb-0"><b>{{product.prod3}}</b> <span style="font-size: 13px">{{product.stile3}} {{product.taglia3}}</span></p>
            </v-col>
        </v-row>


        <v-dialog
                v-model="dialog"
                width="100%"
        >
                <v-img
                        :src="require('../assets/' + product.photo)"
                        :lazy-src="require('../assets/' + product.photomin)"
                        contain
                        width="100%"
                >
                </v-img>

                <v-img
                        v-if="product.retro !== ''"
                        :src="require('../assets/' + product.retro)"
                        :lazy-src="require('../assets/' + product.retromin)"
                        contain
                        width="100%"
                >
                </v-img>


                <v-btn
                        fab
                        small
                        fixed
                        right
                        top
                        color="primary"
                        @click="dialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>


        </v-dialog>


    </div>

</template>

<script>
    export default {
        name: "SingleImageLookbook",
        props: ["product"],

        data: () => ({
            dialog: false,
        }),

        methods: {
            getWidth(src){
                const img = new Image();
                img.src = src;
                console.log(img.width);
                return img.width
            },
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },


        }
    }
</script>

<style scoped>

</style>
